/**
 * Business rules the owner may tune — how many wrong passwords lock an account, how long before
 * broker commission is payable. The server owns the set of keys and validates every value; the
 * dashboard shows the ones that belong on each page, beside the thing they govern.
 */

import { api } from '../api.js';
import { appSettingListTag } from '../tags.js';

export type AppSetting = {
  key: string;
  value: string;
  /** `Text`, `Int`, `Bool` or `Json`. */
  dataType: string;
  description?: string | null;
  updatedAt: string;
};

export const appSettingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    listAppSettings: build.query<AppSetting[], void>({
      query: () => '/settings',
      providesTags: [appSettingListTag()],
    }),

    updateAppSetting: build.mutation<void, { key: string; value: string }>({
      query: ({ key, value }) => ({
        url: `/settings/${encodeURIComponent(key)}`,
        method: 'PUT',
        body: { value },
      }),
      invalidatesTags: [appSettingListTag()],
    }),
  }),
});

export const { useListAppSettingsQuery, useUpdateAppSettingMutation } = appSettingsApi;
